export default "__VITE_ASSET__Bwj0GXmW__"